<ng-container *ngIf="actual">
  <div class="modal-header erp-modal-header">
    <div class="nv-head">
      <!-- Sin <span>: la regla legacy ".modal-header span" de app.scss los pinta blancos. -->
      <div class="nv-meta">
        <div
          class="nv-tipo"
          [style.color]="actual.comportamiento?.color"
          [style.borderColor]="actual.comportamiento?.color"
        >
          <i class="material-icons" aria-hidden="true">{{ actual.comportamiento?.icono }}</i>
          {{ actual.comportamiento?.etiqueta }}
        </div>
        <div *ngIf="actual.codigoVersion" class="nv-muted">Versión {{ actual.codigoVersion }}</div>
        <div class="nv-muted">{{ formatearFecha(actual.fechaPublicacion) }}</div>
      </div>
      <h4 class="modal-title erp-modal-title">{{ actual.titulo }}</h4>
      <p class="erp-modal-subtitle">{{ actual.resumen }}</p>
    </div>
    <button type="button" class="erp-modal-close" (click)="cerrar()" aria-label="Cerrar">
      <i class="material-icons" aria-hidden="true">close</i>
    </button>
  </div>

  <div class="modal-body erp-modal-body nv-body" [class.con-nav]="publicaciones.length > 1">
    <nav *ngIf="publicaciones.length > 1" class="nv-nav" aria-label="Novedades">
      <div class="nv-nav-title">Novedades ({{ publicaciones.length }})</div>
      <button
        *ngFor="let p of publicaciones; let i = index"
        type="button"
        class="nv-nav-item"
        [class.active]="i === indice"
        (click)="seleccionar(i)"
      >
        <i class="material-icons" aria-hidden="true" [style.color]="p.comportamiento?.color">{{ p.comportamiento?.icono }}</i>
        <span>{{ p.titulo }}</span>
      </button>
    </nav>

    <section class="nv-contenido">
      <div *ngIf="actual.cancelada" class="nv-aviso is-danger">
        Esta publicación fue cancelada<span *ngIf="actual.motivoCancelacion">: {{ actual.motivoCancelacion }}</span>.
      </div>
      <div *ngIf="actual.ventana" class="nv-aviso">
        <i class="material-icons" aria-hidden="true">schedule</i>
        <span>
          {{ formatearVentana(actual.ventana) }} (hora de Ecuador).
          <ng-container *ngIf="actual.ventana.bloquea">El sistema no estará disponible durante la ventana.</ng-container>
        </span>
      </div>

      <ng-container *ngIf="paginaActual as p; else sinContenido">
        <span *ngIf="p.etiquetaCategoria" class="nv-categoria">{{ p.etiquetaCategoria }}</span>
        <h5 class="nv-pagina-titulo">{{ p.titulo }}</h5>
        <img *ngIf="p.imagenUrl" class="nv-imagen" [src]="p.imagenUrl" alt="" />
        <div class="nv-html" [innerHTML]="p.contenidoHtml"></div>
      </ng-container>
      <ng-template #sinContenido>
        <p class="nv-muted">Esta publicación no tiene contenido adicional.</p>
      </ng-template>
    </section>
  </div>

  <div class="modal-footer erp-modal-footer">
    <div class="nv-progreso">
      <ng-container *ngIf="paginas.length > 1">
        <span class="nv-dots">
          <button
            *ngFor="let p of paginas; let i = index"
            type="button"
            class="nv-dot"
            [class.active]="i === pagina"
            (click)="pagina = i"
            [attr.aria-label]="'Ir a la página ' + (i + 1)"
          ></button>
        </span>
        <span class="nv-muted">Página {{ pagina + 1 }} de {{ paginas.length }}</span>
      </ng-container>
    </div>
    <button *ngIf="totalPasos > 1" type="button" class="btn-cancel" [disabled]="esPrimerPaso" (click)="anterior()">
      Anterior
    </button>
    <button *ngIf="!esUltimoPaso" type="button" class="btn-save" (click)="siguiente()">
      Siguiente
      <i class="material-icons" aria-hidden="true">chevron_right</i>
    </button>
    <button *ngIf="esUltimoPaso" type="button" class="btn-save" (click)="entendido()">
      <i class="material-icons" aria-hidden="true">check</i>
      Entendido
    </button>
  </div>
</ng-container>
